// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Unibrow-cls1___fe0113a6f2ff3acc458{/*!*/}.Unibrow-cls2___49dd96b4e6fb71c5341{display:flex;justify-content:flex-end;align-items:center;grid-gap:16px;gap:16px;grid-gap:var(--spacing-xs-16, 16px);gap:var(--spacing-xs-16, 16px)}@media(max-width: 567px){.Unibrow-cls2___49dd96b4e6fb71c5341{width:100%;flex-direction:column}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "Unibrow-cls1___fe0113a6f2ff3acc458",
	"cls2": "Unibrow-cls2___49dd96b4e6fb71c5341 Unibrow-cls1___fe0113a6f2ff3acc458"
};
export default ___CSS_LOADER_EXPORT___;
